const gradeApi = {
  GETCOURSERESULTSBYSTUDENTID:
    'CSVPA-China/api/course/getCourseResultsByStudentId', //学生成绩
  UPDATEGRADE: 'CSVPA-China/api/grade/update', //编辑学生成绩
  REEDITGRADE: 'CSVPA-China/api/grade/reedit', //重新编辑
  SENDEMAILCODE: 'CSVPA-China/api/email/sendEmailCode', //授权码
  SUBMITGRADE: 'CSVPA-China/api/grade/submit', //提交成绩
  GETTRANSCRIPTBYSTUDENTID: 'CSVPA-China/api/course/getTranscriptByStudentId', //成绩单
  GETTRANSCRIPTUPDATERECORD: 'CSVPA-China/api/course/getTranscriptUpdateRecord', //修改记录
  GETOFFICALTRANSCRIPTS: 'CSVPA-China/api/course/getOfficalTranscripts', //学生所有成绩
  IMPORTGRADEWORD: 'CSVPA-China/api/grade/importGradeWord', //导出学生成绩单
  IMPORTGRADEWORDBYCLASSID: 'CSVPA-China/api/grade/importGradeWordByClassId', //导出全班学生成绩
  CHECKSUBMITSTATUS: 'CSVPA-China/api/grade/checkSubmitStatus', //提交状态
  IMPORTSEMESTERGRADE: 'CSVPA-China/api/grade/importSemesterGrade', //导出成绩
  IMPORTSEMESTERGRADEALL: 'CSVPA-China/api/grade/importSemesterGradeAll', //批量导出成绩
  CONFIRMUPDATEGRADE: 'CSVPA-China/api/grade/confirm', //确认修改成绩
  TURNDOWNUPDATEGRADE: 'CSVPA-China/api/grade/turnDown', //拒绝修改成绩
  GETFEEDBACKBYSTUDENTID: 'CSVPA-China/api/feedback/getByStudentId', //班主任反馈
  GETBYVALIDFEEDBACK: 'CSVPA-China/api/feedback/getByValidFeedback', //已审核班主任反馈
  UPDATEFEEDBACK: 'CSVPA-China/api/feedback/update', //填写反馈
  REEDITFEEDBACK: 'CSVPA-China/api/feedback/reedit', //编辑反馈
  GETFEEDBACKUPDATE: 'CSVPA-China/api/feedback/getFeedbackUpdate', //获取提交的的反馈信息
  CONFIRMUPDATEFEEDBACK: 'CSVPA-China/api/feedback/confirm', //确认修改反馈信息
  TURNDOWNUPDATEFEEDBACK: 'CSVPA-China/api/feedback/turnDown', //拒绝修改反馈信息
  GETUPDATERECORDBYSTUDENTID:
    'CSVPA-China/api/feedback/getUpdateRecordByStudentId', //反馈信息记录
  GETTERMSTRANSCRIPTSFINAL: 'CSVPA-China/api/course/getTermsTranscriptsFinal', //期末成绩
  GETOFFICIALTRANSCRIPTS: 'CSVPA-China/api/course/getOfficialTranscripts', //最后成绩
  IMPORTTERMSTRANSCRIPTSFINAL:
    'CSVPA-China/api/course/importTermsTranscriptsFinal', //导出学期成绩
  IMPORTTERMSTRANSCRIPTSFINALALL:
    'CSVPA-China/api/course/importTermsTranscriptsFinalAll', //导出班级学期成绩
  IMPORTOFFICIALTRANSCRIPTS: 'CSVPA-China/api/course/importOfficialTranscripts', //导出学年成绩
  IMPORTOFFICIALTRANSCRIPTSALL:
    'CSVPA-China/api/course/importOfficialTranscriptsAll', //导出班级学年成绩
  GETBASICTRANSCRIPTUPDATE:
    'CSVPA-China/api/basiGrade/getBasicTranscriptUpdate', //提交的修改basiGrade
  CONFIRMBASICTRANSCRIPTUPDATE: 'CSVPA-China/api/basiGrade/confirm', //确认提交的修改basiGrade
  TURNDOWNBASICTRANSCRIPTUPDATE: 'CSVPA-China/api/basiGrade/turnDown', //拒绝提交的修改basiGrade
  GETQUIZTRANSCRIPTUPDATE: 'CSVPA-China/api/quizGrade/getQuizTranscriptUpdate', //提交的修改quizGrade
  CONFIRMQUIZTRANSCRIPTUPDATE: 'CSVPA-China/api/quizGrade/confirm', //确认提交的修改quizGrade
  TURNDOWNQUIZTRANSCRIPTUPDATE: 'CSVPA-China/api/quizGrade/turnDown', //拒绝提交的修改quizGrade
  GETSTUDENTSUBJECT: 'CSVPA-China/api/course/getByStudentId', //按学生查询学科
  GETSTUDENTGRADE: 'CSVPA-China/api/course/getGradeByStudentId', //按学生查询平时成绩
  GETBASICGRADEBYSTUDENTID:
    'CSVPA-China/api/basiGrade/getBasicGradeByStudentId', //周内平时成绩查询
  WRITEBASEGRADE: 'CSVPA-China/api/basiGrade/writeBaseGrade', //按学生导出周内平时成绩
  GETTERMEXAMCOURSEBYSTUDENTID:
    'CSVPA-China/api/course/getTermExamCourseByStudentId'
}

export default gradeApi
